import React, { useState } from "react";
import { Button, Table } from "antd";
import CustomPagination from "../components/Pagination";
import type { TableColumnsType } from "antd";
import { LinkOutlined } from "@ant-design/icons";

interface LinksTableProps {
  Links: any[];
}

function LinksTable({ Links }: LinksTableProps) {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;
  const columns: TableColumnsType<any> = [
    {
      title: "الاسم",
      dataIndex: "name",
      key: "name",
      width: "50%",
    },
    {
      title: "الرابط",
      dataIndex: "link",
      key: "link",
      width: "50%",
      render: (link: string) => (
        <a href={link} target="_blank" rel="noopener noreferrer">
          <LinkOutlined style={{ marginLeft: 5 }} />
          اضغط هنا{" "}
        </a>
      ),
    },
  ];

  const paginatedTasks = Links.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div>
      <Table
        columns={columns}
        dataSource={paginatedTasks}
        pagination={false}
        rowKey="id"
        locale={{
          emptyText: (
            <span className="ghaith--empty-text-table">
              لا توجد بيانات تخص روابط الصور و الفيديوهات
            </span>
          ),
        }}
      />
      {Links?.length > pageSize &&(
      <CustomPagination
        current={currentPage}
        total={Links.length}
        pageSize={pageSize}
        onChange={(page: any) => setCurrentPage(page)}
      />)}
    </div>
  );
}

export default LinksTable;
